// extracted by mini-css-extract-plugin
export default {"div":"GroupSection_div__W0aVE","pocket":"GroupSection_pocket__IXNte","button":"GroupSection_button__wk4Ey"};